import { useLocation } from 'react-router-dom';

import { useCreateUrl } from '@/hooks/useNavigate';

const useMainMenu = () => {
  const actualLocation = useLocation();
  const createUrl = useCreateUrl();

  const activeRoute = actualLocation.pathname.substring(1).split('/');

  return {
    activeRoute,
    createUrl,
  };
};

export default useMainMenu;
